import styled from "styled-components";

export const ActionButton = styled.div<{ disabled?: boolean }>`
background-color: #EFEFEF;
padding: 3px 8px;
font-weight: bold;
color: ${({ disabled }) => (disabled ? '#C8C8C8' : '#A0A0A0')};
border-radius: 4px;
cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
margin: 0 3px;
opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
pointer-events: ${({ disabled }) => (disabled ? 'none' : 'auto')};
`
export const MainPagination = styled.div`
display: flex;
align-items: center;
width: 100%;
justify-content: flex-end;
`